export default {
    "created": "Caracteristica a fost creată cu succes.",
    "updated": "Caracteristica a fost actualizată cu succes.",
    "deleted": "Caracteristica a fost ștearsă cu succes.",
    "restored": "Caracteristica a fost restaurată cu succes.",
}
